import type { BaseInputTemplateProps } from '@rjsf/utils';
import { getInputProps } from '@rjsf/utils';
import { TextField } from '@mui/material';
import type { ReactElement } from 'react';

export function BaseInputTemplate({
  id,
  value,
  readonly,
  disabled,
  autofocus,
  onBlur,
  onFocus,
  onChange,
  options,
  schema,
  type,
  rawErrors = [],
  placeholder,
}: BaseInputTemplateProps): ReactElement {
  const inputProps = getInputProps(schema, type, options);

  return (
    <TextField
      id={id}
      value={value ?? ''}
      disabled={disabled}
      autoFocus={autofocus}
      placeholder={placeholder}
      error={rawErrors.length > 0}
      onChange={({ target: { value: v } }) => onChange(v === '' ? options.emptyValue : v)}
      onBlur={({ target: { value: v } }) => onBlur(id, v)}
      onFocus={({ target: { value: v } }) => onFocus(id, v)}
      fullWidth
      size="small"
      inputProps={{ ...inputProps, readOnly: readonly }}
    />
  );
}
